import { render, staticRenderFns } from "./static-report-ribbon.vue?vue&type=template&id=002a1d67&scoped=true"
import script from "./static-report-ribbon.vue?vue&type=script&lang=ts"
export * from "./static-report-ribbon.vue?vue&type=script&lang=ts"
import style0 from "./static-report-ribbon.vue?vue&type=style&index=0&id=002a1d67&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a1d67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('002a1d67')) {
      api.createRecord('002a1d67', component.options)
    } else {
      api.reload('002a1d67', component.options)
    }
    module.hot.accept("./static-report-ribbon.vue?vue&type=template&id=002a1d67&scoped=true", function () {
      api.rerender('002a1d67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/final-report/static-report-edit/static-report-ribbon.vue"
export default component.exports